import { useState, useEffect } from 'react'

class ObservableArray extends Array {
    constructor(...args) {
        super(...args)
        this.pushCallback = null
    }

    setPushCallback(callback) {
        this.pushCallback = callback
    }

    push(...args) {
        super.push(...args)
        if (this.pushCallback) {
            this.pushCallback(this)
        }
        return this.length
    }
}

const consentStatusLayer =
    typeof window !== 'undefined'
        ? new ObservableArray(
              ...(window.consentStatusLayer || []),
          )
        : []

if (typeof window !== 'undefined') {
    window.consentStatusLayer = consentStatusLayer

    consentStatusLayer.setPushCallback((newArray) => {
        const nextConsentStatus =
            newArray[newArray.length - 1]
        if (typeof window !== 'undefined') {
            if (nextConsentStatus === 'PENDING') {
                window.dispatchEvent(
                    new Event('consentPending'),
                )
            } else if (nextConsentStatus === 'GIVEN') {
                window.dispatchEvent(
                    new Event('consentGiven'),
                )
            }
        }
    })
}

export const ConsentStatus = {
    UNKNOWN: 'UNKNOWN',
    PENDING: 'PENDING',
    GIVEN: 'GIVEN',
}

export const useConsentStatus = () => {
    const [consentStatus, setConsentStatus] = useState(
        typeof window !== 'undefined'
            ? consentStatusLayer[
                  consentStatusLayer.length - 1
              ]
            : ConsentStatus.UNKNOWN,
    )

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const handleConsentPendingEvent = () => {
                setConsentStatus(ConsentStatus.PENDING)
            }

            const handleConsentGivenEvent = () => {
                setConsentStatus(ConsentStatus.GIVEN)
            }

            window.addEventListener(
                'consentPending',
                handleConsentPendingEvent,
            )

            window.addEventListener(
                'consentGiven',
                handleConsentGivenEvent,
            )

            return () => {
                window.removeEventListener(
                    'consentGiven',
                    handleConsentGivenEvent,
                )

                window.removeEventListener(
                    'consentPending',
                    handleConsentPendingEvent,
                )
            }
        }
    }, [])

    return consentStatus
}
